import { baseColors } from './baseColors';
import { paletteColorsLightMode } from './paletteColorsLightMode';
const text = {
    highContrast: {
        on: {
            background: paletteColorsLightMode.stroke.neutral.text.highContrast.on.background,
            subtle: paletteColorsLightMode.stroke.neutral.text.highContrast.on.subtle,
            strong: paletteColorsLightMode.stroke.neutral.text.highContrast.on.strong,
            darkImage: paletteColorsLightMode.stroke.neutral.text.highContrast.on.strong,
            lightImage: paletteColorsLightMode.stroke.neutral.text.highContrast.on.subtle,
        },
    },
    primary: {
        on: {
            background: paletteColorsLightMode.stroke.neutral.text.primary.on.background,
            subtle: paletteColorsLightMode.stroke.neutral.text.primary.on.subtle,
            strong: paletteColorsLightMode.stroke.neutral.text.primary.on.strong,
        },
    },
    secondary: {
        on: {
            background: paletteColorsLightMode.stroke.neutral.text.secondary.on.background,
            subtle: paletteColorsLightMode.stroke.neutral.text.secondary.on.subtle,
            strong: paletteColorsLightMode.stroke.neutral.text.secondary.on.strong,
        },
    },
    tertiary: {
        on: {
            background: paletteColorsLightMode.stroke.neutral.text.tertiary.on.background,
            subtle: paletteColorsLightMode.stroke.neutral.text.tertiary.on.subtle,
            strong: paletteColorsLightMode.stroke.neutral.text.tertiary.on.strong,
        },
    },
    critical: {
        on: {
            background: paletteColorsLightMode.stroke.critical.text.on.background,
        },
    },
    caution: {
        on: {
            background: paletteColorsLightMode.stroke.caution.text.on.background,
        },
    },
};
const textOverlay = {
    transparent: {
        fill: baseColors.transparent.white['0075'],
        content: {
            on: {
                fill: baseColors.grayscale['0750'],
                content: baseColors.grayscale['0000'],
            },
        },
    },
};
const button = {
    primary: {
        fill: {
            on: {
                background: text.primary.on.background,
            },
        },
        border: {
            on: {
                background: text.primary.on.background,
            },
        },
        content: {
            on: {
                background: paletteColorsLightMode.fill.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: text.secondary.on.background,
                },
            },
            border: {
                on: {
                    background: text.secondary.on.background,
                },
            },
            content: {
                on: {
                    background: paletteColorsLightMode.fill.background,
                },
            },
        },
    },
    secondary: {
        fill: {
            on: {
                background: paletteColorsLightMode.fill.background,
            },
        },
        border: {
            on: {
                background: text.primary.on.background,
            },
        },
        content: {
            on: {
                background: text.primary.on.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: paletteColorsLightMode.fill.subtle,
                },
            },
            border: {
                on: {
                    background: text.primary.on.subtle,
                },
            },
            content: {
                on: {
                    background: text.primary.on.subtle,
                },
            },
        },
    },
    tertiary: {
        fill: {
            on: {
                background: text.secondary.on.strong,
            },
        },
        border: {
            on: {
                background: text.secondary.on.strong,
            },
        },
        content: {
            on: {
                background: text.primary.on.subtle,
            },
        },
        hover: {
            fill: {
                on: {
                    background: text.tertiary.on.strong,
                },
            },
            border: {
                on: {
                    background: text.tertiary.on.strong,
                },
            },
            content: {
                on: {
                    background: text.highContrast.on.subtle,
                },
            },
        },
    },
    info: {
        fill: {
            on: {
                background: paletteColorsLightMode.fill.info.strong,
            },
        },
        border: {
            on: {
                background: paletteColorsLightMode.fill.info.strong,
            },
        },
        content: {
            on: {
                background: paletteColorsLightMode.fill.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: paletteColorsLightMode.stroke.info.text.on.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsLightMode.stroke.info.text.on.subtle,
                },
            },
            content: {
                on: {
                    background: paletteColorsLightMode.fill.background,
                },
            },
        },
    },
    celebratory: {
        fill: {
            on: {
                background: paletteColorsLightMode.fill.celebratory.strong,
            },
        },
        border: {
            on: {
                background: paletteColorsLightMode.fill.celebratory.strong,
            },
        },
        content: {
            on: {
                background: paletteColorsLightMode.fill.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: paletteColorsLightMode.stroke.celebratory.text.highContrast.on.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsLightMode.stroke.celebratory.text.highContrast.on.subtle,
                },
            },
            content: {
                on: {
                    background: paletteColorsLightMode.fill.background,
                },
            },
        },
    },
    caution: {
        fill: {
            on: {
                background: paletteColorsLightMode.fill.caution.strong,
            },
        },
        border: {
            on: {
                background: paletteColorsLightMode.fill.caution.strong,
            },
        },
        content: {
            on: {
                background: paletteColorsLightMode.fill.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: paletteColorsLightMode.stroke.caution.text.on.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsLightMode.stroke.caution.text.on.subtle,
                },
            },
            content: {
                on: {
                    background: paletteColorsLightMode.fill.background,
                },
            },
        },
    },
    critical: {
        fill: {
            on: {
                background: paletteColorsLightMode.fill.critical.strong,
            },
        },
        border: {
            on: {
                background: paletteColorsLightMode.fill.critical.strong,
            },
        },
        content: {
            on: {
                background: paletteColorsLightMode.fill.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: paletteColorsLightMode.stroke.critical.text.on.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsLightMode.stroke.critical.text.on.subtle,
                },
            },
            content: {
                on: {
                    background: paletteColorsLightMode.fill.background,
                },
            },
        },
    },
    disabled: {
        fill: {
            on: {
                background: paletteColorsLightMode.fill.disabled.subtle,
            },
        },
        border: {
            on: {
                background: paletteColorsLightMode.fill.disabled.subtle,
            },
        },
        content: {
            on: {
                background: paletteColorsLightMode.stroke.disabled.text.on.subtle,
            },
        },
    },
};
const link = {
    primary: {
        on: {
            background: text.primary.on.background,
        },
    },
};
const badge = {
    neutral: {
        fill: {
            on: {
                background: paletteColorsLightMode.fill.background,
            },
        },
        border: {
            on: {
                background: paletteColorsLightMode.stroke.neutral.border.decoration.on.background,
            },
        },
        content: {
            on: {
                background: text.primary.on.background,
            },
        },
    },
    highlight: {
        fill: {
            on: {
                background: paletteColorsLightMode.fill.info.subtle,
            },
        },
        border: {
            on: {
                background: baseColors.blue.darkest,
            },
        },
        content: {
            on: {
                background: baseColors.blue.darkest,
            },
        },
    },
};
const input = {
    empty: {
        fill: {
            on: {
                background: paletteColorsLightMode.fill.background,
            },
        },
        border: {
            on: {
                background: paletteColorsLightMode.stroke.neutral.border.interaction.secondary.on.background,
            },
        },
        content: {
            on: {
                background: text.secondary.on.background,
            },
        },
    },
    filled: {
        fill: {
            on: {
                background: paletteColorsLightMode.fill.background,
            },
        },
        border: {
            on: {
                background: paletteColorsLightMode.stroke.neutral.border.interaction.primary.on.background,
            },
        },
        content: {
            on: {
                background: text.primary.on.background,
            },
        },
    },
    selected: {
        fill: {
            on: {
                background: paletteColorsLightMode.stroke.neutral.border.interaction.primary.on.background,
            },
        },
        border: {
            on: {
                background: paletteColorsLightMode.stroke.neutral.border.interaction.primary.on.background,
            },
        },
        content: {
            on: {
                background: paletteColorsLightMode.fill.background,
            },
        },
    },
    invalid: {
        empty: {
            fill: {
                on: {
                    background: paletteColorsLightMode.fill.background,
                },
            },
            border: {
                on: {
                    background: text.critical.on.background,
                },
            },
            content: {
                on: {
                    background: text.secondary.on.background,
                },
            },
        },
        filled: {
            fill: {
                on: {
                    background: paletteColorsLightMode.fill.background,
                },
            },
            border: {
                on: {
                    background: text.critical.on.background,
                },
            },
            content: {
                on: {
                    background: text.primary.on.background,
                },
            },
        },
        selected: {
            fill: {
                on: {
                    background: text.critical.on.background,
                },
            },
            border: {
                on: {
                    background: text.critical.on.background,
                },
            },
            content: {
                on: {
                    background: paletteColorsLightMode.fill.background,
                },
            },
        },
    },
    disabled: {
        empty: {
            fill: {
                on: {
                    background: paletteColorsLightMode.fill.disabled.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsLightMode.stroke.neutral.border.interaction.tertiary.on.background,
                },
            },
            content: {
                on: {
                    background: paletteColorsLightMode.stroke.neutral.text.secondary.on.subtle,
                },
            },
        },
        filled: {
            fill: {
                on: {
                    background: paletteColorsLightMode.fill.disabled.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsLightMode.stroke.neutral.border.interaction.secondary.on.background,
                },
            },
            content: {
                on: {
                    background: paletteColorsLightMode.stroke.neutral.text.secondary.on.subtle,
                },
            },
        },
        selected: {
            fill: {
                on: {
                    background: paletteColorsLightMode.stroke.neutral.border.interaction.secondary.on.background,
                },
            },
            border: {
                on: {
                    background: paletteColorsLightMode.stroke.neutral.border.interaction.secondary.on.background,
                },
            },
            content: {
                on: {
                    background: paletteColorsLightMode.fill.background,
                },
            },
        },
    },
};
const effect = {
    focus: {
        outline: {
            on: {
                background: paletteColorsLightMode.stroke.focused.outline.on.background,
            },
        },
    },
    skeleton: {
        fill: {
            on: {
                background: paletteColorsLightMode.stroke.neutral.border.decoration.on.background,
            },
        },
        overlay: {
            on: {
                background: paletteColorsLightMode.stroke.neutral.border.decoration.on.background,
            },
        },
    },
};
export const themeColorsLightMode = {
    ...paletteColorsLightMode,
    text,
    textOverlay,
    button,
    link,
    badge,
    input,
    effect,
};
//# sourceMappingURL=themeColorsLightMode.js.map